export const CART_EVENTS = {
	CART_FLYOUT_SHOW: "cart-flyout:show",
	CART_FLYOUT_RERENDER: "cart-flyout:rerender",
	CART_BUTTON_UPDATE_COUNTER: "cart-button:update-counter",
	CART_FLYOUT_HIDDEN: "cart-flyout:hidden",
	CART_FLYOUT_SHOWN: "cart-flyout:shown",
};

export function dispatchEvent(event: keyof typeof CART_EVENTS, detail?: unknown): void {
	document.body.dispatchEvent(new CustomEvent(CART_EVENTS[event], { detail }));
}

export function listenToEvent(event: keyof typeof CART_EVENTS, callback: (event: CustomEvent) => void): void {
	document.body.addEventListener(CART_EVENTS[event], (e) => callback(e as CustomEvent));
}
